import React from 'react';

const ArchivePageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/archive',
			exact: true,
			component: React.lazy(() => import('./ArchivePage')),
		},
	],
};

export default ArchivePageConfig;
